import { $win, getCurrentDevice } from './utils';

export default function headerUI() {
	const $header = $('.header:not(.header--blog)');
	const headerBarHeight = $('.header__bar').outerHeight();
	let lastScrollTop = 0;

	if ( getCurrentDevice() !== 'mobile' ) {
		$win.on('scroll', function() {
			const currentScrollTop = $win.scrollTop();

			if (currentScrollTop > lastScrollTop){
				$header.toggleClass('pull', currentScrollTop > headerBarHeight)
			} else {
				$header.removeClass('pull')
			}

			lastScrollTop = currentScrollTop;

			$header.toggleClass('shrink', currentScrollTop > $win.height())
		});
	} else {
		$header.addClass('shrink')
		
		$win.on('scroll', function() {
			const currentScrollTop = $win.scrollTop();

			$header.toggleClass('mobile-scrolling', currentScrollTop > $win.height())
		});
	}
}
